import { memo } from "react";
import { useTranslation } from "react-i18next";
import Input from "../../Components/Input";
import CountrySelect from "../../Components/CountrySelect";

import { countries } from "../../Components/CountrySelect/countries";

const LoactionDetails = memo(
  ({ formData, handleInputChange, userCountryCode }) => {
    const { t } = useTranslation();
    const selectedCountry = countries.find(
      (item) => item.code === userCountryCode,
    );

    return (
      <>
        <section>
          <h4> {t("userProfile.section_location_header")}</h4>
          <CountrySelect
            onChange={(newValue) =>
              handleInputChange({
                target: { name: "country", value: newValue },
              })
            }
            defaultValue={selectedCountry}
          />
          <Input
            label={t("input_label_city")}
            name="city"
            value={formData.city || ""}
            onChange={handleInputChange}
            required
          />
          <Input
            label={t("input_label_district")}
            name="district"
            value={formData.district || ""}
            onChange={handleInputChange}
            required
          />
          <Input
            label={t("input_label_address")}
            name="address"
            value={formData.address || ""}
            onChange={handleInputChange}
            required
          />
        </section>
      </>
    );
  },
);

export default LoactionDetails;
